'use client';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
export default function AiSearchUuid() {
    useEffect(() => {
        if (!sessionStorage.getItem('ef_search_ai_session_id')) {
            sessionStorage.setItem('ef_search_ai_session_id', uuidv4());
        }
    }, []);
    return null;
}
